export default class MeigarasearchBaseService {
  getAll(meigaraKey) {
    return fetch("https://api.tradersr.com/api/meigarasearch_base?meigara=" + meigaraKey)
      .then(res => res.json());
  }
}